<template>
  <v-container fluid style="padding:0px;">
    <v-layout row wrap class="stretch-columns">
      <v-flex md6 sm12 xs12 class="new-info-table">
        <v-card class="bordered-card">
          <v-toolbar color="white" class="homepage-tool elevation-0 black--text" >
            <h5 style="font-size: 16px; font-weight: 400" class="pa-4">New users</h5>
          </v-toolbar>
          <v-card-text class="grey lighten-3" style="padding:0px">
            <v-data-table
              :headers="topusersHeaders"
              :items="topusers"
              hide-actions
              :loading="loadingUsers"
            >
              <template slot="items" slot-scope="props">
                <td class="avatar-cell"><img :src="props.item.avatar" class="avatar img-avatar"/></td>
                <td>{{ props.item.firstname }} {{ props.item.lastname }}</td>
                <td>{{ props.item.companylegalname }}</td>
                <td><a :href="props.item.email" :style="{color: styles.general.theme_color_light}">{{ props.item.email }}</a></td>
                <td>{{ props.item.jobtitle }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 sm12 xs12 class="new-users-table" style="padding-left:10px;">
        <v-card class="bordered-card">
          <v-toolbar color="white" class="homepage-tool elevation-0 black--text" >
            <h5 style="font-size: 16px; font-weight: 400" class="pa-4">New Companies</h5>
          </v-toolbar>
          <v-card-text class="grey lighten-3" style="padding:0px">
            <v-data-table
              :headers="topcompaniesHeaders"
              :items="newUnverifiedCompanies"
              hide-actions
              no-data-text="All company submissions have been approved"
            >
              <template slot="items" slot-scope="props">
                <td class="avatar-cell"><img :src="props.item.companylogo" class="avatar img-avatar"/></td>
                <td>{{ props.item.companylegalname }}</td>
                <td>{{ props.item.state }}</td>
                <td>{{ props.item.firstname }} {{ props.item.lastname }}</td>
                <td>{{ props.item.submitdate }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      events() {
        return this.$store.getters.fetchEvents;
      },
      loading() {
        return this.$store.getters.getLoading;
      },
      error() {
        return this.$store.getters.getError;
      },
      updateProcess() {
        return this.$store.getters.getProcess === "Settings Saved";
      },
      newUnverifiedCompanies () {
        const companies = this.$store.getters.getCompanySubmissions
	      return companies.filter(company => {
          if (company.submitted && !company.verified) {
            return company
          }
        })
      },
      process() {
        return this.$store.getters.getProcess;
      },
      allEvents() {
        if (this.currentStatus || this.currentStatus === 0 || this.currentDate) {
          return this.events.filter(
            event =>
              event.approvalstatus === this.currentStatus ||
              event.date < this.currentDate
          );
        }
        return this.events;
      },
      styles() {
        return this.$store.getters.getStyles;
      }
    },
    data() {
      return {
        search: "",
        e1: "",
        pagination: {},
        dialog: false,
        currentStatus: "",
        loadingUsers: false,
        currentEventId: "",
        currentDate: "",
        view_dialog: false,
        topusers: [],
        topusersHeaders: [
          {
            value: "avatar",
            text: "Image",
            align: "left",
            sortable: false
          },
          {
            value: "firstname",
            text: "Name",
            align: "left"
          },
          {
            value: "companylegalname",
            text: "Company",
            align: "left"
          },
          {
            value: "email",
            text: "Email by",
            align: "left"
          },
          {
            value: "jobtitle",
            text: "Job title",
            align: "left"
          }
        ],
        topcompanies: [],
        topcompaniesHeaders: [
          {
            value: "companylogo",
            text: "Logo",
            align: "left",
            sortable: false
          },
          {
            value: "companylegalname",
            text: "Company",
            align: "left"
          },
          {
            value: "state",
            text: "State",
            align: "left"
          },
          {
            value: "firstname",
            text: "Submitted by",
            align: "left"
          },
          {
            value: "submitdate",
            text: "Approval date",
            align: "left"
          }
        ],
        headers: [
          {
            text: "Submit Date",
            align: "left",
            sortable: false,
            value: "eventdate"
          },
          {
            text: "Company",
            value: "user",
            align: "center",
            sortable: false
          },
          {
            text: "Event Title",
            value: "title",
            align: "center",
            sortable: false
          },
          {
            text: "Event Date",
            align: "center",
            sortable: false,
            value: "posteddate"
          },
          {
            text: "Status",
            value: "status",
            align: "center",
            sortable: false
          },
          {
            text: "Actions",
            value: "action",
            align: "center",
            sortable: false
          }
        ],
        status_filter: [
          {
            text: "All",
            value: ""
          },
          {
            text: "Approved",
            value: 1
          },
          {
            text: "Pending",
            value: 0
          },
          {
            text: "Rejected",
            value: 2
          }
        ],
        default_filter: [
          {
            text: "Option 1"
          },
          {
            text: "Option 2"
          },
          {
            text: "Option 3"
          }
        ],
        items: []
      };
    },
    methods: {
      async getPhotoUrl(uid, index) {
        let user = await this.$firebase
          .database()
          .ref("users/" + uid)
          .once("value");
        return user;
      },
      changeStatus(status, postId) {
        const payload = {
          type: "events",
          status,
          postId
        };
        this.$store.dispatch("changeStatus", payload);
      },
      filterStatus(status) {
        this.currentStatus = status;
      },

      deleteRow() {
        const payload = {
          type: "events",
          postId: this.currentEventId
        };
        this.$store.dispatch("deletePost", payload);
      },
      assignId(postId) {
        this.currentEventId = postId;
      }
    },
    mounted() {
      var self = this;
      var fb = this.$firebase.database().ref();
      self.topcompanies = [];
      this.loadingUsers = true
      this.$firebase.database().ref().child('users').orderByChild('createdAt').limitToLast(5).on('value', async (snapshot) => {
        const results = []
        const newUsers = snapshot.val()
        const keys = Object.keys(newUsers)
        for (var key of keys) {
          const data = newUsers[key]
          const companySnapshot = await fb.child('companies/' + data.cid.toString()).once('value')
          const cdata = companySnapshot.val()
          if (cdata && cdata.companylegalname !== null) {
            data.companylegalname = cdata.companylegalname
          } else {
            data.companylegalname = 'N/A'
          }
          results.push(data)
        }
        self.loadingUsers = false
        self.topusers = results
      })
      this.$store.dispatch('fetchCompanySubmissions')
    }
  };
</script>
<style lang="scss" scoped>
h5 {
  font-weight: 500;
}
#right {
  float: right !important;
}
.listx {
  height: 70px;
  padding: 10px 0;
}
.avatar-cell {
  padding: 24px !important;
}
.img-avatar {
  height: 50px;
}
.new-info-table:first-child {
  @media (max-width: 767px) {
    margin-right: 20px;
  }
}
.stretch-columns {
  align-items: stretch;
}
.bordered-card {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// block.1.vue?1a4fc9d4